import React, { useEffect, useRef } from 'react';

const PREVIEW_VIDEO_URL =
  process.env.REACT_APP_PREVIEW_VIDEO_URL ||
  'https://brrmediauk-brrmedia-assets.s3.us-east-1.amazonaws.com/holding-video/preview+video.mp4';

const PreviewVideo = () => {
  const videoRef = useRef(null);

  useEffect(() => {
    const video = videoRef.current;
    if (!video) return undefined;

    // Browsers still allow unmuting via keyboard media keys, PiP windows or devtools.
    const forceMuted = () => {
      if (!video.muted || video.volume !== 0) {
        video.muted = true;
        video.volume = 0;
      }
    };

    forceMuted();
    video.addEventListener('volumechange', forceMuted);
    video.play().catch(() => {});

    return () => video.removeEventListener('volumechange', forceMuted);
  }, []);

  return (
    <div className='videoWrapper'>
      <video
        ref={videoRef}
        src={PREVIEW_VIDEO_URL}
        autoPlay
        muted
        loop
        playsInline
        disablePictureInPicture
        disableRemotePlayback
        controls={false}
        controlsList='nodownload nofullscreen noremoteplayback'
        onContextMenu={(e) => e.preventDefault()}
        style={{
          position: 'absolute',
          top: 0,
          left: 0,
          width: '100%',
          height: '100%',
          objectFit: 'contain',
          backgroundColor: '#000',
        }}
      />
    </div>
  );
};

export default PreviewVideo;
